import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@assets/img/arrow-left.svg'
import _imports_1 from '@assets/img/no_image.svg'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = {
  key: 0,
  src: "/src/assets/img/burger-white.svg",
  style: {"top":"-14px"}
}
const _hoisted_3 = {
  key: 1,
  src: _imports_0,
  alt: "",
  srcset: "",
  style: {"height":"20px","top":"-10px","left":"5px"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "header__update" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "icon-apteka-database" })
  ])
], -1)
const _hoisted_5 = { class: "header__user-panel" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "ico-image"
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "header__user-text" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  title: "Выход из учетной записи"
}, "Выход", -1)
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", {
      class: "header__mobile-btn",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickBurger && _ctx.onClickBurger(...args)))
    }, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (_ctx.hideMenu)
            ? (_openBlock(), _createElementBlock("img", _hoisted_2))
            : (_openBlock(), _createElementBlock("img", _hoisted_3))
        ]),
        _: 1
      })
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: "header__user-photo",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeProfile && _ctx.changeProfile(...args)))
      }, _hoisted_7),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          class: "user__name",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changeProfile && _ctx.changeProfile(...args))),
          title: "Войти в профиль"
        }, _toDisplayString(_ctx.userName), 1),
        _createElementVNode("div", {
          class: "user",
          onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onLogout && _ctx.onLogout(...args)), ["stop"]))
        }, _hoisted_10)
      ])
    ])
  ]))
}